// src/pages/Publisher/Campaigns/components/CampaignTableRow.tsx
import React, { useState } from 'react';
import { Campaign } from '../types';
import StatusBadge from '@/components/StatusBadge';
import CampaignInsightsDialog from './CampaignInsightsDialog';
import { Icons } from '@/icons';
import RemoteFile from '@/helper/RemoteFile';
import { formatLocalDate } from '@/utils/FormateLocalDate';
import MoreMenu from '@/components/MoreMenu';

interface Props {
  campaign: Campaign;
  idx: string;
  anchorEl: HTMLElement | null;
  rowIdx: string | null;
  onMenuOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onMenuClose(): void;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
}

const CampaignTableRow: React.FC<Props> = ({
  campaign,
  idx,
  anchorEl,
  rowIdx,
  onMenuOpen,
  onMenuClose,
  onDelete,
  onArchive,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <tr className='border-b'>
        <td className='p-2'>
          <RemoteFile
            keyPath={campaign.image_url}
            key={campaign.gamic_title}
            className='w-[56px]'
          />
        </td>
        <td className='p-4'>{campaign.gamic_title}</td>
        <td className='p-4'>{campaign.title}</td>
        <td className='p-4'>{`${formatLocalDate(campaign.start_date)} - ${formatLocalDate(campaign.end_date)}`}</td>
        <td className='p-4'>{campaign.total_budget}</td>
        <td className='p-4'>{campaign.spent ? campaign.spent : 0}</td>
        <td className='p-4'>{campaign.cpe}</td>
        <td className='p-4'>{campaign.cpd}</td>
        <td className='p-4'>
          <StatusBadge status={campaign.status} />
        </td>
        <td className='p-4'>
          <button
            onClick={() => setOpen(true)}
            className='active:bg-gray-100 rounded-[5px]'
          >
            {/* <Icons.Menu /> */}
          </button>
          <MoreMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && rowIdx === idx}
            onOpen={onMenuOpen}
            onClose={onMenuClose}
            rowIdx={rowIdx}
            idx={idx}
            onDelete={onDelete}
            onArchive={onArchive}
            isEdit={false}
            setOpen={setOpen}
          />
          <CampaignInsightsDialog
            open={open}
            onClose={() => setOpen(false)}
            title='Campaign Insights'
            gamicTitle={campaign.gamic_title}
            dateRange={`${formatLocalDate(campaign.start_date)} - ${formatLocalDate(campaign.end_date)}`}
            campaignName={campaign.title}
            id={campaign.id}
          />
        </td>
      </tr>
    </>
  );
};

export default CampaignTableRow;
